// Константы для переиспользуемых CSS классов

// Input стили (следуя стандартам читаемости форм)
export const INPUT_BASE = "w-full px-3 py-2 rounded-lg border-2 border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:border-blue-500 dark:focus:border-blue-400 outline-none transition-colors";

// Select стили
export const SELECT_BASE = INPUT_BASE;

// Textarea стили
export const TEXTAREA_BASE = INPUT_BASE;

// Label стили
export const LABEL_TEXT = "text-sm text-gray-600 dark:text-gray-400 mb-1";

// Button стили
export const BUTTON_CARD = "p-4 rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-left transition-colors";

// Card стили
export const CARD_BASE = "p-4 border border-gray-200 dark:border-gray-700 rounded-2xl bg-white dark:bg-gray-800";

// Image стили
export const IMAGE_THUMBNAIL = "w-full h-24 object-cover rounded-xl border border-gray-200 dark:border-gray-700";
